import React, { useMemo, useState } from 'react';

import Context from './FrequentlyBoughtTogetherContext';

type FrequentlyBoughtTogetherProviderProps = {
    products: Array<LP.product.ProductItem>,
	mainShortSku: string
}

const FrequentlyBoughtTogetherProvider = ({ children, products, mainShortSku }: React.PropsWithChildren<FrequentlyBoughtTogetherProviderProps>) => {

	const [ selectedProducts, setSelectedProducts ] = useState<Array<LP.product.ProductItem>>(products);
	const selectedProductsCount = selectedProducts.length;
	// memoize calculation of total price so it's only re-calculated when selecting/deselecting FBT products
	const selectedProductsTotalPrice: number = useMemo(() => {

		const calculatedTotal = selectedProducts
			.map((product) => Number(product.DisplayPrice))
			.reduce((price, total) => {

				// eslint-disable-next-line no-param-reassign
				total += price;
				return total;

			}, 0).toFixed(2);

		return parseFloat(calculatedTotal);

	}, [ selectedProducts ]);

	function selectProduct (product: LP.product.ProductItem) {

		setSelectedProducts([ ...selectedProducts, product ]);

	}

	function deselectProduct (shortSku: string) {

		const updatedProducts = selectedProducts.filter((p) => p.ShortSku !== shortSku);
		setSelectedProducts(updatedProducts);

	}

	return (
		<Context.Provider value={{
			products,
			selectedProducts,
			selectedProductsTotalPrice,
			selectedProductsCount,
			mainShortSku,
			selectProduct,
			deselectProduct
		}}
		>
			{children}
		</Context.Provider>
	);

};

export default FrequentlyBoughtTogetherProvider;
